import { fetchEndpoint } from '../server/network'
import Cookie from 'js-cookie'
import store from '../store/index'

// 
export const configGet =
() =>
fetchEndpoint(
  '/v2/ecapi.config.get',
  'POST',
  {
    cid: Cookie.get('cid')
  }
)



// WEBPACK FOOTER //
// ./src/api/config.js